import React, { useState } from "react";
import {
  InputBase,
  IconButton,
  Paper,
  FormControl,
  OutlinedInput,
  InputLabel,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import styles from "./serachInput.module.scss";

const SearchInput = ({ placeholder = "", onSearch, minWidth }) => {
  const [query, setQuery] = useState("");

  const handleSearch = () => {
    if (onSearch) onSearch(query);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") handleSearch();
  };

  return (
    <div className={styles.container}>
      {/* <InputBase sx={{ ml: 1, flex: 1 }} />
      <IconButton type="button" onClick={handleSearch} sx={{ p: "10px" }}>
        <SearchIcon />
      </IconButton> */}
      <FormControl style={{ minWidth: minWidth || "200px" }}>
        <InputLabel>Search</InputLabel>
        <OutlinedInput
          placeholder={placeholder}
          value={query}
          classes={{ root: styles.input }}
          onChange={(e) => {
            const value = e.target.value;
            setQuery(value);
            if (onSearch) onSearch(value);
          }}
          label="Search"
          endAdornment={<SearchIcon />}
        />
      </FormControl>
    </div>
  );
};

export default SearchInput;
